var productionMode = false;
const urlStart = 'https://asmoid-stock-dash.qtrust.id';

export default {productionMode , urlStart};
